import {rolesService} from 'services';

export const SET_ROLES_LIST = 'SET_ROLES_LIST';
export const FETCH_ROLES_LIST = 'FETCH_ROLES_LIST';

const rolesStore = {
  namespaced: true,
  state () {
    return {
      rolesList: []
    };
  },
  getters: {
    rolesList: state => state.rolesList
  },
  mutations: {
    [SET_ROLES_LIST] (state, rolesList) {
      state.rolesList = rolesList;
    }
  },
  actions: {
    async [FETCH_ROLES_LIST] (context) {
      const roles = await rolesService.getRolesList();
      context.commit(SET_ROLES_LIST, roles.items);
    }
  }
};

export default rolesStore;
